import { Component, ContentChild, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { INgClass } from '../../types';

@Component({
    standalone: true,
    imports: [
        CommonModule
    ],
    selector: 'pmis3-ui-page-template',
    templateUrl: './page-template.component.html',
})
export class Pmis3UiPageTemplateComponent {
    @Input() style: any;

    @ContentChild('body') _body: HTMLDivElement | undefined;
    @ContentChild('header') _header: HTMLDivElement | undefined;

    @Input() Icon = 'event';
    @Input() Title = 'Page Template';
    @Input() bodyClass: INgClass | undefined;
    @Input() titleWidth: number | 'auto' = 'auto';
    @Input() titleClass: INgClass | undefined;
    @Input() helpFileName: string | undefined;

    _screenSize: ScreenSizeTypes = 'md';
    get screenSize(): ScreenSizeTypes {
        return (
            this._screenSize !== 'xs' ? `-${this._screenSize}` : ''
        ) as ScreenSizeTypes;
    }
    @Input() set screenSize(val: ScreenSizeTypes) {
        this._screenSize = val;
    }

    get rightHeaderClass(): string {
        let _headerClass = 'col' + this.screenSize;
        if (this.titleWidth !== 'auto' && this.titleWidth < 12)
            _headerClass = `col${this.screenSize}-${12 - this.titleWidth}`;
        return _headerClass;
    }

    openHelp() {
        alert('TODO: Help');
    }
}

export type ScreenSizeTypes = 'xs' | 'md' | 'lg';
